<template>
    <div>
        <ul class="nrk work">
            <li v-for="item in Member.data" :key="item.id" @click="Details(item.id)">
                <div class="nmkimg">
                    <img v-lazy="Http+item.logo">
                </div>
                <span>{{item.title}}</span>
            </li>
        </ul>
        <Pagination 
        :pageNo="date.page" 
        :pageSize='date.limit' 
        :total="Member.total" 
        :continues="5"
        @getPageNo='getPageNo'
        />
    </div>
</template>

<script>
 import{mapState} from'vuex';
export default {
    data() {
        return {
            date:{
                cid:2,
                limit:9,
                page:1,
            }
        }
    },
    activated() {
        this.postNews(this.date)
    },
    computed:{
        ...mapState({
            Member:state=>state.share.Member,
            Http:state=>state.share.Http,
        })
    },
    methods: {
        Details(id){
            this.$router.push({
                name:'ActivityDetails',
                    query:{
                        id:id,
                    }
            })
        },
        getPageNo(id){
            this.date.page=id
            this.postNews(this.date)
        },
        postNews(naml){
            this.$store.dispatch('PostMember',naml);
        }
    },
}
</script>

<style scoped>
    .work{
        overflow: hidden;
        margin: 20px auto;
        padding: 2% 0;
    }
    .work li{
        width: 32%;
        float: left;
        background-color: #f0eadf;
        margin-right: 2%;
        cursor: pointer;
        box-shadow: 0px 3px 3px #d9d9d9;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        margin-bottom: 30px;
    }
    .work li:nth-child(3n){
        margin-right: 0;
    }
    .work li::after{
        content: '';
        position: absolute;
        top: 3.5%;
        left: 3.5%;
        width: 50px;
        height: 50px;
        background-color: blue;
        background: url(../../../../../img/xq.png) no-repeat;
    }
    .work li img{
        width: 100%;
        height: 260px;
    }
    .work li .nmkimg{
        width: 86%;
        margin: 0 auto;
        display: block;
        margin-top: 7%;
        border-radius: 10px;
        overflow: hidden;
        height: 260px;
        overflow: hidden;
    }
    .work li:hover img {
        transform: scale(1.1);
        transition: all 0.5s ease;
    } 
    .work li span{
        text-align: center;
        display: block;
        margin: 34px 0;
        font-size: 18px;
    }
    @media (max-width: 768px){
        .work li{
            width: 100%;
        }
        .work li .nmkimg,.work li img{
            height: auto;
        }
    }
</style>